<template>
  <div class="ssvip">
    <main>
      <div class="download-btn" @click="download">
        立享特权
      </div>
    </main>
    <footer>
      <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间15.4%-24%，单利计算)</p>
      <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
      <p class="mt24">重庆市崇天小额贷款有限公司</p>
      <p>公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
      <p>渝公网安备 50010802002638号I渝ICP备18009772号-1</p>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'landing-s-s-vip-two',
  data () {
    return {
    }
  },
  methods: {
    download () {
      this.downloadApp()
      // let url = `tianmeiqianbao://`
      // window.location = url
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.ssvip{
  min-height:100%;
  width:100%;
  background: #FFBE8C;
  main{
    position: relative;
    background: url('https://static.ndmicro.com/tmd/landing/vip/images/img_011@2x.png');
    background-size: cover;
    width:750px;
    height:1209px;
    // margin-bottom:81px;
  }
  .download-btn{
      width: 560px;
      height: 154px;
      background: url('https://static.ndmicro.com/tmd/landing/vip/images/btn_jiekuan@2x.png') center no-repeat;
      background-size: cover;
      color: #fff;
      font-size: 36px;
      text-align: center;
      line-height: 154px;
      font-weight: bold;
      bottom: 460px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      0% {
          transform:translateX(-50%) scale(1);
      }
      50% {
          transform:translateX(-50%) scale(0.9);
      }
      100% {
          transform:translateX(-50%) scale(1);
      }
  }
  footer{
    width: 750px;
    background: #EEA46D;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    padding:24px 30px;
    .mt24{
      margin-top:24px;
    }
  }
}
</style>